import { useEffect, useState } from 'react'
import { Select, MenuItem, SelectChangeEvent, Box, Typography, Link, useTheme } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { ESettingsModelOrToolFields } from 'src/types'

interface IProps {
  models: string[]
  activeModel: string
  showImageSuportWarning?: boolean
  field: ESettingsModelOrToolFields
  onModelChange: (model: string, field: ESettingsModelOrToolFields) => void
  isLoading: boolean
}

export const ModelSelect = ({
  models,
  activeModel,
  field,
  onModelChange,
  showImageSuportWarning = false,
  isLoading,
}: IProps) => {
  const [selectedModel, setSelectedModel] = useState<string>(activeModel ?? '')

  useEffect(() => {
    setSelectedModel(activeModel)
  }, [activeModel])

  const theme = useTheme()

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value
    setSelectedModel(value)
    onModelChange(value, field)
  }

  // if (!models || !models.length) {
  //   return null
  // }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        ml: '50px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Typography>Model in use:</Typography>
        <Select
          labelId="model-select-label"
          id="model-select"
          value={selectedModel}
          onChange={handleChange}
          size="small"
          disabled={isLoading}
        >
          {models?.map((model) => (
            <MenuItem key={model} value={model}>
              {model}
            </MenuItem>
          ))}
        </Select>
      </Box>
      {showImageSuportWarning && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            backgroundColor: theme.palette.custom.warning3,
            border: `1px solid ${theme.palette.custom.warning2}`,
            padding: '8px',
            borderRadius: '10px',
          }}
        >
          <WarningAmberIcon sx={{ color: theme.palette.custom.warning2 }} fontSize="small" />
          <Typography sx={{ color: theme.palette.custom.darkBlue2, fontSize: '12px' }}>
            Only models that support images as input should be selected. You can check if a model
            supports images{' '}
            <Link
              href="https://platform.openai.com/docs/models/compare"
              target="_blank"
              rel="noopener"
              color="inherit"
            >
              here
            </Link>
            .
          </Typography>
        </Box>
      )}
    </Box>
  )
}
